import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Benefit, BenefitChartResponse, BenefitEdition, BenefitEditionDefaultStatus, BenefitFilter, BenefitImageUploadResponse, BenefitPageableResponse } from '@app-model/benefit';
import { FilterOptions } from '@app-model/filter';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})

export class BenefitService {
	constructor(private http: HttpClient) {}

	getBenefits(data) {
		return this.http.post(`${environment.api}/admin/benefits/list`, data).pipe(
			map((response: BenefitPageableResponse) => response),take(1)
		);
	}

	getBenefit(id) {
		return this.http.get(`${environment.api}/admin/benefits/${id}`).pipe(
			map((response: Benefit) => response),take(1)
		);
	}

	downloadCSV(filter: FilterOptions) {
		return this.http.post(`${environment.api}/admin/benefits/csv/download`, filter, {
			responseType: 'blob'
		});
	}

  	updateBenefit(event: BenefitEdition): Observable<BenefitEditionDefaultStatus> {
		return this.http.post(`${environment.api}/admin/benefits/save`, event)
			.pipe(
				map((response: BenefitEditionDefaultStatus) => response)
			);
	}

	uploadBenefitImage(benefitId: string, image: File): Observable<BenefitImageUploadResponse> {
		const formData = new FormData();
		formData.append('file', image);

		return this.http.post(`${environment.api}/admin/benefits/${benefitId}/upload-image`, formData)
			.pipe(
				map((response: BenefitImageUploadResponse) => response)
			);
	}

	uploadBenefitFile(benefitId: string, file: File): Observable<BenefitImageUploadResponse> {
		const formData = new FormData();
		formData.append('file', file);
		
		return this.http.post(`${environment.api}/admin/benefits/${benefitId}/upload-content`, formData)
			.pipe(
				map((response: BenefitImageUploadResponse) => response)
			);
	}

	/**
	 * @deprecated replaced by method `updateBenefit`
	 * @param event
	 * @returns
	 */
	saveBenefit(event: Benefit): Observable<Benefit> {
		return this.http.post(`${environment.api}/admin/benefits/save`, event)
    		.pipe(map((response: Benefit) => response));
	}

	removeBenefit(obj: Benefit): Observable<Benefit> {
		return this.http.delete(`${environment.api}/admin/benefits/${obj.id}`)
    		.pipe(map((response: Benefit) => response));
	}

	getBenefitCharts(filter: BenefitFilter): Observable<BenefitChartResponse> {
		return this.http.post(`${environment.api}/admin/benefits/`, filter)
    		.pipe(map((response: BenefitChartResponse) => response));
	}

}

